import { app } from 'config/ApiService';
import { getFunctions, httpsCallable, HttpsCallableResult } from 'firebase/functions';

export interface ServiceResponse {
    message: string;
    success?: boolean;
    [key: string]: any;
}

export type ProgrammePayloadSchema = {
    name: string;
    body_areas: string[];
    number_of_levels: number;
    session_per_level: number;
    id?: string | null | undefined;
    number_of_exercises_per_session?: number | null | undefined;
    status?: 'active' | 'inactive' | null | undefined;
    region?: string | null | undefined;
};

export interface IPhioengageService<RequestData, ResponseData> {
    invoke: (
        data: RequestData,
        serviceId: string
    ) => Promise<HttpsCallableResult<ResponseData> | void>;
}

const REGION_MAPPING: { [key: string]: string } = {
    us: 'us-central1',
    gb: 'europe-west2',
    aus: 'australia-southeast1',
    au: 'australia-southeast1'
};

/**
 * PhioengageService
 */
class PhioengageService<
    T extends { region?: string | null | undefined },
    U
> implements IPhioengageService<T, U> {
    /**
     *
     * @param data - Request data
     * @param serviceId - Service ID e.g phioengage-programme-create
     * @throws {Error} - Throws error if service fails
     * @returns {Promise<HttpsCallableResult<U> | void>}
     */
    async invoke(data: T, serviceId: string): Promise<HttpsCallableResult<U> | void> {
        const regionOrDomain = data.region
            ? REGION_MAPPING[data.region] || 'us-central1'
            : 'us-central1';
        const callable = getFunctions(app, regionOrDomain);
        const endpoint = httpsCallable<T, U>(callable, serviceId);
        return endpoint(data);
    }
}

export default PhioengageService;
